'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Input fields for setting own strategy or barrier
 */
var SetStrategies = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(SetStrategies, _Component);

  function SetStrategies() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SetStrategies);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SetStrategies.__proto__ || (0, _getPrototypeOf2.default)(SetStrategies)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (index, event) {
      _this.props.handleChange(index, event.target.value);
    }, _this.handleAdd = function () {
      _this.props.handleAdd();
    }, _this.handleRemove = function (index, event) {
      event.preventDefault();
      _this.props.handleRemove(index);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SetStrategies, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Row,
          null,
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              null,
              this.props.inputfields.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: _this2.props.type + index },
                  _react2.default.createElement(
                    ReactBootstrap.InputGroup,
                    null,
                    _this2.props.type === 'barrier' && _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', bsSize: 'large',
                      placeholder: 'Set a ' + _this2.props.type, onChange: _this2.handleChange.bind(_this2, index),
                      value: _this2.props.inputfields[index] }),
                    _this2.props.type === 'strategy' && _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', bsSize: 'large',
                      placeholder: 'Set a ' + _this2.props.type, onChange: _this2.handleChange.bind(_this2, index),
                      value: _this2.props.inputfields[index].strategy }),
                    _react2.default.createElement(
                      ReactBootstrap.InputGroup.Button,
                      null,
                      _react2.default.createElement(
                        ReactBootstrap.Button,
                        { bsSize: 'large', bsStyle: 'danger',
                          onClick: _this2.handleRemove.bind(_this2, index) },
                        _react2.default.createElement('i', { className: 'fa fa-close' })
                      )
                    )
                  ),
                  _react2.default.createElement('br', null)
                );
              }),
              _react2.default.createElement(
                ReactBootstrap.ButtonToolbar,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Button,
                  { bsStyle: 'success', onClick: this.handleAdd },
                  _react2.default.createElement('i', { className: 'fa fa-plus' }),
                  '  Add ',
                  this.props.type
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SetStrategies;
}(_react.Component), _class.propTypes = {
  type: _propTypes2.default.string, // either 'barrier' or 'strategy'
  handleAdd: _propTypes2.default.func.isRequired,
  handleRemove: _propTypes2.default.func.isRequired,
  handleChange: _propTypes2.default.func.isRequired,
  inputfields: _propTypes2.default.array // pass in an array of things here, could be an array of barriers
}, _temp2);
exports.default = SetStrategies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/SetStrategies.js
// module id = 1219
// module chunks = 0